import React, { Component } from 'react'
import PropTypes from 'prop-types'

class EventCreateModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      errorMessage: ''
    }

    this.input = React.createRef()
  }

  componentDidMount() {
    this.input.current.focus()
  }

  addNewEvent = (e) => {
    e.preventDefault()

    const { title } = this.state

    if (!title) {
      this.setState({errorMessage: "Please insert title"})
    } else {
      this.props.createEvent({title, start: '2018-05-05 10:00:00', end: '2018-05-05 15:00:00'})
      this.props.setModal(false)
    }
  }

  render() {
    const { title } = this.state

    return (
      <div className="modal-content">
        <h3>Create new event</h3>

        <form onSubmit={this.addNewEvent}>
          <ul data-error-msg={this.state.errorMessage}>
            <li data-title="Event's title">
              <input ref={this.input}
                type="text"
                className="input--light"
                value={title}
                onChange={(e) => this.setState({title: e.target.value})} />
            </li>
          </ul>

          <button className="button--success" type="submit">Create event</button>
        </form>
      </div>
    )
  }
}

EventCreateModal.propTypes = {
  createEvent: PropTypes.func,
  setModal: PropTypes.func
}

EventCreateModal.defaultProps = {
  createEvent: function() {},
  setModal: function() {}
}

export default EventCreateModal



// WEBPACK FOOTER //
// ./src/components/modals/event-create-modal.js